import React from 'react';

// §6 耳朵细节 — 耳朵 A/B/C (ear-a/b/c-color) — base layer
// HOOD mode
// Extracted verbatim from the original Hood.js renderer; element order is
// significant (SVG z-order, later = painted on top) — do not reorder.

export function EarSection({ config, parts }) {
  return (
    <>
<path className={"hood-" + config['ear-a-color'] + " str_332C2B_20"} d={parts['ear-a-color_c'] || ''}/>
<path className={"hood-" + config['ear-c-color']} d={parts['ear-c-color_c'] || ''}/>
<path className={"hood-" + config['ear-b-color']} d={parts['ear-b-color_c'] || ''}/>
<path className={"hood-" + config['ear-c-color'] + " str_332C2B_20"} d={parts['ear-c-color_c_2'] || ''}/>
    </>
  );
}
